module.exports = __webpack_public_path__ + "img/MEDIA048.bdf2e54d.jpg";